<script>
export default {
  data() {
    return {
      interlinings: [],
      interliningColors: [],
      isReadOnlyUser: false,
      formData: {},
      editId: null,
      errors: {},
    }
  },
  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only"
    this.fetchInterlinings()
    this.fetchInterliningColors()
  },
  methods: {
    /*
     * Interlining functions
     */
    async fetchInterlinings() {
      try {
        let res = await axios.get("v2/fabrics/interlinings");
        this.interlinings = res.data.data;
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error("Unable to load interlinings");
        }
      }
    },
    showCreateDialog() {
      this.editId = null;
      this.errors = {};
      this.formData = {};
      show_modal("#interlining-modal-box");
    },
    async createInterlining() {
      try {
        let res = await axios.post("v2/fabrics/interlinings", this.formData);
        if (res) {
          await this.fetchInterlinings();
          toastr.success("Success");
          hide_modal("#interlining-modal-box");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          this.errors = error.response.data.errors;
          toastr.error(error.response.data.message);
        }
      }
    },
    showUpdateDialog(interlining) {
      this.errors = {};
      this.formData = {
        id: interlining.id,
        code: interlining.code
      }
      this.editId = interlining.id;
      show_modal("#interlining-modal-box");
    },
    async updateInterlining() {
      try {
        let res = await axios.put("v2/fabrics/interlinings/" + this.editId, this.formData);
        if (res) {
          await this.fetchInterlinings();
          toastr.success("Success");
          hide_modal("#interlining-modal-box");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          this.errors = error.response.data.errors;
          toastr.error(error.response.data.message);
        }
      }
    },
    async deleteInterlining(interlining) {
      let result = await Swal.fire({
        title: "Are you sure to Delete?",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "NO",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "DELETE",
      });

      if (!result.value) {
        return;
      }
      try {
        let res = await axios.delete("v2/fabrics/interlinings/" + interlining.id);
        if (res) {
          await this.fetchInterlinings();
          toastr.success("SUCCESS");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "Unable to delete this interlining, contact the admins for help!"
          );
        }
      }
    },

    /*
     * Interlining colors functions
     */
    async fetchInterliningColors() {
      try {
        let res = await axios.get("v2/fabrics/interlining_colors");
        this.interliningColors = res.data.data;
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error("Unable to load interlinings");
        }
      }
    },
    showCreateColorDialog() {
      this.editId = null;
      this.errors = {};
      this.formData = {};
      show_modal("#interlining-color-modal-box");
    },
    async createInterliningColor() {
      try {
        let res = await axios.post("v2/fabrics/interlining_colors", this.formData);
        if (res) {
          await this.fetchInterliningColors();
          toastr.success("Success");
          hide_modal("#interlining-color-modal-box");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          this.errors = error.response.data.errors;
          toastr.error(error.response.data.message);
        }
      }
    },
    showColorUpdateDialog(interlining) {
      this.errors = {};
      this.formData = {
        id: interlining.id,
        code: interlining.code,
        name_en: interlining.name_en,
        name_th: interlining.name_th
      }
      this.editId = interlining.id;
      show_modal("#interlining-color-modal-box");
    },
    async updateInterliningColor() {
      try {
        let res = await axios.put("v2/fabrics/interlining_colors/" + this.editId, this.formData);
        if (res) {
          await this.fetchInterliningColors();
          toastr.success("Success");
          hide_modal("#interlining-color-modal-box");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          this.errors = error.response.data.errors;
          toastr.error(error.response.data.message);
        }
      }
    },
    async deleteInterliningColor(interlining) {
      let result = await Swal.fire({
        title: "Are you sure to Delete?",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "NO",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "DELETE",
      });

      if (!result.value) {
        return;
      }
      try {
        let res = await axios.delete("v2/fabrics/interlining_colors/" + interlining.id);
        if (res) {
          await this.fetchInterliningColors();
          toastr.success("SUCCESS");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "Unable to delete this interlining color, contact the admins for help!"
          );
        }
      }
    },
  }
}
</script>

<template>
  <div>
    <div class="row">
      <div class="col-md-5">
        <div class="grid bg-white">
          <div class="grid-title">
            <h4 class="text-bold">Interlinings</h4>
          </div>
          <div class="grid-body">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th class="sort">#ID</th>
                  <th class="text-right">
                    <button
                      class="btn btn-success"
                      @click="showCreateDialog()"
                      v-if="!isReadOnlyUser"
                    >
                      <i class="fa fa-plus-circle" aria-hidden="true"></i> New Interlining
                    </button>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(interlining, index) in interlinings"
                  :key="index"
                >
                  <td>{{ interlining.code }}</td>
                  <td class="text-right">
                    <button
                      class="btn btn-primary"
                      @click="showUpdateDialog(interlining)"
                      v-if="!isReadOnlyUser"
                    >
                      <i class="fa fa-edit" aria-hidden="true"></i>
                      Edit
                    </button>
                    <button
                      class="btn btn-danger"
                      @click="deleteInterlining(interlining)"
                      v-if="!isReadOnlyUser"
                    >
                      <i class="fa fa-trash-o" aria-hidden="true"></i>
                      Delete
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-md-7">
        <div class="grid bg-white">
          <div class="grid-title">
            <h4 class="text-bold">Interlining Colors</h4>
          </div>
          <div class="grid-body">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th class="sort">Code</th>
                  <th class="sort">Name EN</th>
                  <th class="sort">Name TH</th>
                  <th class="text-right">
                    <button
                      class="btn btn-success"
                      @click="showCreateColorDialog()"
                      v-if="!isReadOnlyUser"
                    >
                      <i class="fa fa-plus-circle" aria-hidden="true"></i> New Interlining Color
                    </button>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(interlining, index) in interliningColors"
                  :key="index"
                >
                  <td>{{ interlining.code }}</td>
                  <td>{{ interlining.name_en }}</td>
                  <td>{{ interlining.name_th }}</td>
                  <td class="text-right">
                    <button
                      class="btn btn-primary"
                      @click="showColorUpdateDialog(interlining)"
                      v-if="!isReadOnlyUser"
                    >
                      <i class="fa fa-edit" aria-hidden="true"></i>
                      Edit
                    </button>
                    <button
                      class="btn btn-danger"
                      @click="deleteInterliningColor(interlining)"
                      v-if="!isReadOnlyUser"
                    >
                      <i class="fa fa-trash-o" aria-hidden="true"></i>
                      Delete
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Interlining Modal -->
    <div
      class="modal fade"
      id="interlining-modal-box"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-bold" v-if="editId != null">
              Update Interlining
            </h5>
            <h5 class="modal-title text-bold" v-else>New Interlining</h5>
          </div>
          <div class="modal-body bg-white">
            <div class="form-group">
              <label>ID</label>
              <input
                type="text"
                class="form-control"
                v-model="formData.code"
                placeholder="Interlining ID"
              />
              <small v-if="errors.code" class="form-text text-danger">{{
                errors.code.join(" ")
              }}</small>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              v-if="editId != null"
              @click="updateInterlining()"
            >
              Update
            </button>
            <button
              type="button"
              class="btn btn-primary"
              v-else
              @click="createInterlining()"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Interlining Color Modal -->
    <div
      class="modal fade"
      id="interlining-color-modal-box"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-bold" v-if="editId != null">
              Update Interlining Color
            </h5>
            <h5 class="modal-title text-bold" v-else>New Interlining Color</h5>
          </div>
          <div class="modal-body bg-white">
            <div class="form-group">
              <label>Code</label>
              <input
                type="text"
                class="form-control"
                v-model="formData.code"
                placeholder=""
              />
              <small v-if="errors.code" class="form-text text-danger">{{
                errors.code.join(" ")
              }}</small>
            </div>
            <div class="form-group">
              <label>Name EN</label>
              <input
                type="text"
                class="form-control"
                v-model="formData.name_en"
                placeholder=""
              />
              <small v-if="errors.name_en" class="form-text text-danger">{{
                errors.name_en.join(" ")
              }}</small>
            </div>
            <div class="form-group">
              <label>Name TH</label>
              <input
                type="text"
                class="form-control"
                v-model="formData.name_th"
                placeholder=""
              />
              <small v-if="errors.name_th" class="form-text text-danger">{{
                errors.name_th.join(" ")
              }}</small>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              v-if="editId != null"
              @click="updateInterliningColor()"
            >
              Update
            </button>
            <button
              type="button"
              class="btn btn-primary"
              v-else
              @click="createInterliningColor()"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
